export function getHook (ad) {
  // Extracts the hook from an ad (the first sentence or two of the transcription)

  if (ad?.displayHook) return ad.displayHook

  const transcription = ad?.timestampedTranscription || ad?.cards?.[0]?.timestampedTranscription || []
  const firstSentence = transcription[0]?.sentence || ''
  const secondSentence = transcription[1]?.sentence || ''
  const sentenceEndingRegex = /(?<!Dr|Mr|Ms|Mrs)[.!?]/
  const firstSentenceEndIndex = firstSentence.search(sentenceEndingRegex)
  if (firstSentenceEndIndex !== -1) {
    return firstSentence.substring(0, firstSentenceEndIndex + 1)
  } else {
    const secondSentenceEndIndex = secondSentence.search(sentenceEndingRegex)
    if (secondSentenceEndIndex !== -1) {
      return firstSentence + secondSentence.substring(0, secondSentenceEndIndex + 1)
    } else {
      return firstSentence + secondSentence + '...'
    }
  }
}

export function isManualUpload (ad) {
  // Server uploads set save_source, older uploads (and the mobile app) only have the name
  return ad?.save_source === 'MANUAL_UPLOAD' || ad?.name === 'Manual Upload'
}
